import Store from "../../types/Store";

const dummyStore: Store = {
  city: "",
  categoryId: "",
  shortDescription: "",
  createdAt: "",
  coverURL: "",

  subcategory: "",
  address: "",
  description: "",
  id: "",
  email: "",

  phoneNumber: "",

  storeCode: "",
  storeName: "",
  verified: false,
  stars: -1,
  reviews: -1,
  logoURL: "",
  website: "",
};
const store = (state: Store = dummyStore, action) => {
  switch (action.type) {
    case "SET_STORE":
      return action.payload;
    default:
      return state;
  }
};

export default store;
